module.exports = "/ui/b6c1fcffa05e561f94b04ae08f305349.png";